import { render, staticRenderFns } from "./combined-courses.vue?vue&type=template&id=effb2318&scoped=true&"
import script from "./combined-courses.vue?vue&type=script&lang=js&"
export * from "./combined-courses.vue?vue&type=script&lang=js&"
import style0 from "./combined-courses.vue?vue&type=style&index=0&id=effb2318&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effb2318",
  null
  
)

export default component.exports